import { render, staticRenderFns } from "./playgame-page.vue?vue&type=template&id=5a9c08f1&scoped=true"
import script from "./playgame-page.vue?vue&type=script&lang=js"
export * from "./playgame-page.vue?vue&type=script&lang=js"
import style0 from "./playgame-page.vue?vue&type=style&index=0&id=5a9c08f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9c08f1",
  null
  
)

export default component.exports